module.exports = __webpack_public_path__ + "img/1452490739.71ff176b.jpg";